import React from "react";
import Section from "../../components/section/Section";
import ReceptionistOpening from "./components/receptionist-opening/ReceptionistOpening";
import ReceptionistVoice from "./components/receptionist-voice/ReceptionistVoice";

const YourReceptionist = () => {
  return (
    <Section
      title="Your Receptionist"
      subtitle="Your voice, your choice! Personalize your AI experience to reflect your unique brand essence."
      content={
        <>
          <ReceptionistVoice />
          <ReceptionistOpening />
        </>
      }
      overrideStyle={{ title: { color: "red" } }}
    />
  );
};

export default YourReceptionist;
